<template>
  <div>
    <UserMain />
  </div>
</template>

<script>
import UserMain from '@/components/Settings/UserMain'

export default {
  components: {
    UserMain
  },
  created: async function () {
    await this.$store.dispatch('user/fetchUser')
    this.$store.dispatch('user/resetAttrs')
  }
}
</script>
